import { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";

export default function OutreachModal({ title, children, onClose, busy = false, error, submitLabel = "Save" }) {
  const dialog = useRef(null), titleId = useId(), formId = useId();
  const formContent = typeof children === "function";
  const trapFocus = event => {
    if (event.key !== "Tab") return;
    const controls = [...dialog.current.querySelectorAll("button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),a[href],summary,[contenteditable=true],[tabindex='0']")].filter(element => element.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); dialog.current.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };
  useEffect(() => {
    const previousFocus = document.activeElement;
    const element = dialog.current;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    element.showModal();
    const firstField = element.querySelector("input:not([type=hidden]),select,textarea,[contenteditable=true]");
    firstField?.focus();
    return () => {
      element.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);
  return createPortal(<dialog ref={dialog} className="bookstore-page outreach-modal" aria-labelledby={titleId} onKeyDown={trapFocus} onCancel={event => {
    event.preventDefault();
    if (!busy) onClose();
  }}>
    <header className="outreach-modal-header"><h2 id={titleId}>{title}</h2><button type="button" aria-label={`Close ${title}`} disabled={busy} onClick={onClose}>×</button></header>
    <div className="outreach-modal-body"><fieldset className="outreach-workspace outreach-modal-content" disabled={busy}>
      {error && <p className="bookstore-error" role="alert">{error}</p>}
      {formContent ? children(formId) : children}
    </fieldset></div>
    <footer className="outreach-modal-footer">{formContent && <button type="submit" form={formId} disabled={busy}>{submitLabel}</button>}<button type="button" className="outreach-modal-cancel" disabled={busy} onClick={onClose}>Cancel</button></footer>
  </dialog>, document.body);
}
